// AccountService
import AccountService from "../../account/services/AccountService";

// Namespaced
export const namespaced = true;

export const state = {
  accessToken: null
};
export const mutations = {
  SET_ACCESS_TOKEN(state, accessToken) {
    state.accessToken = accessToken;
  },
  DELETE_ACCESS_TOKEN(state) {
    state.accessToken = null;
  }
};
export const actions = {
  myAccount({ dispatch, commit }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("loginUser", payload)
        .then(() => {
          resolve();
          commit("mutateAlert", "sucessfullyLogin", { root: true });
          dispatch("creator/myAccount", { atLogin: true }, { root: true });
          dispatch("organization/myAccount", null, { root: true });
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  loginUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AccountService.loginUser(payload)
        .then(accessToken => {
          commit("SET_ACCESS_TOKEN", accessToken);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  logOut({ commit }) {
    AccountService.logOutUser();
    commit("DELETE_ACCESS_TOKEN");
    location.reload();
  },
  autoLogIn({ commit }, accessToken) {
    commit("SET_ACCESS_TOKEN", accessToken);
    AccountService.setAuthorizationHeader(accessToken);
  }
};
export const getters = {
  loggedIn(state) {
    return !!state.accessToken;
  }
};
